import { AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NzSelectComponent } from "ng-zorro-antd/select";

// interface Option {
//   label: string;
//   value: any;
//   i18nKey?: string;
// }

export const SELECT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectComponent),
  multi: true,
};

@Component({
  selector: "host-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
  providers: [SELECT_VALUE_ACCESSOR],
})
export class SelectComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() listOfOption: Option[] = [];
  @Input(/** @deprecated @compat */ "defaultValue") placeholderValue = null;
  @Input() placeholder = "";
  @Input() borderless = true;
  @Input() showSearch = false;
  @Input() showArrow = false;
  @Input() disabled = false;
  @Input() size: "default" | "large" = "default";
  /** @deprecated 实现ControlValueAccessor之后，无需手动input */
  @Input() value = null;
  /** @deprecated */
  @Output() valueChange = new EventEmitter();
  open = false;
  _registerOnChange: (value: any) => void = (_: any) => {};
  constructor() {}

  ngOnInit() {}

  ngAfterViewInit(): void {}

  onValueChange(value) {
    this.valueChange.emit(value);
    this._registerOnChange(value);
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any): void {
    this.value = value;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
